import {
  downloadHtmlAsPdf,
  getUnifiedPrintHtml,
  printHtmlViaIframe
} from "../../../utils/pdfDownloadHelper";

export const escapeReportValue = (value) =>
  String(value ?? "-")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

export const buildReportTable = ({ heading, subtitle, columns, rows }) => `
  <section class="print-report-page">
    <h1 style="font-size:20px;margin:0 0 4px;text-align:center">${escapeReportValue(heading)}</h1>
    <p style="font-size:11px;margin:0 0 14px;text-align:center;color:#475569">${escapeReportValue(subtitle)}</p>
    <table style="width:100%;border-collapse:collapse;font-size:10px">
      <thead><tr>${columns.map((column) => `<th style="border:1px solid #0f172a;padding:6px;background:#e2e8f0">${escapeReportValue(column.label)}</th>`).join("")}</tr></thead>
      <tbody>${rows.length ? rows.map((row) => `<tr>${columns.map((column) => `<td style="border:1px solid #0f172a;padding:6px">${escapeReportValue(row[column.key])}</td>`).join("")}</tr>`).join("") : `<tr><td colspan="${columns.length}" style="border:1px solid #0f172a;padding:12px;text-align:center">No records</td></tr>`}</tbody>
    </table>
  </section>`;

export const outputCampReport = async ({ title, body, action, orientation = "landscape" }) => {
  const html = getUnifiedPrintHtml(title, body, { orientation });
  if (action === "print") {
    printHtmlViaIframe(html);
    return;
  }
  await downloadHtmlAsPdf(html, title.replace(/\s+/g, "_"), { orientation });
};
